const getRandomCode = (length = 6) => {
  return Math.random().toString(16).substr(2, length).toUpperCase();
};

exports.getRandomCode = getRandomCode;
